module.exports = __webpack_public_path__ + "941f77db65c5807c10edb07a2d4a99b1.svg";